<div class="fx-row fx-wrap align-items-center justify-content-start fx-flex-50 border-box p-16">
  <ng-content select="[label]"/>
  <!-- body -->
  <ng-content/>
</div>
